import Enchante101 from '../../../Media/BSD/Enchante/Enchante 12.webp'
import Enchante102 from '../../../Media/BSD/Enchante/Enchante 12.webp'





const Enchante10images =[ Enchante101,Enchante102
]

export default Enchante10images;